import { render } from "./WillSidebar.vue?vue&type=template&id=116137d0&ts=true"
import script from "./WillSidebar.vue?vue&type=script&lang=ts"
export * from "./WillSidebar.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__